import { render, staticRenderFns } from "./PlayerPendingAddDataInputRewardForVip.vue?vue&type=template&id=c06ca2b4&"
import script from "./PlayerPendingAddDataInputRewardForVip.vue?vue&type=script&lang=js&"
export * from "./PlayerPendingAddDataInputRewardForVip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports